export const ROUTES_PREFIX = "/order-website";

export const VIEW_MENU_ROUTE = ROUTES_PREFIX + "/view-menu";
export const ORDER_SUCCESS_ROUTE = ROUTES_PREFIX + "/order-success";
export const CHECKOUT_ROUTE = ROUTES_PREFIX + "/checkout";
export const EMPTY_CART_ROUTE = ROUTES_PREFIX + "/empty";
export const ACCOUNT_LOGIN_ROUTE = "/customer/account/login";
